// extracted by mini-css-extract-plugin
export default {"assignment_feed":"AssignmentFeed_assignment_feed__6dgZB","noAssignmentOrQuiz":"AssignmentFeed_noAssignmentOrQuiz__Axv6p","loader":"AssignmentFeed_loader__HyOjT"};